export default __webpack_public_path__ + "static/media/bottom-part-pattern-m.52f99ceb.png";